import { Row } from 'antd';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
// import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import React from 'react';
import paymentMethods from 'styles/images/paymentMethods.png';

interface IObchodniPodminky {
    setShowTerms?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ObchodniPodminky: React.FC<IObchodniPodminky> = ({ setShowTerms }) => {
    return (
        <StatementWrapper pageTitle="">
            {/* <Paragraph text="PODMINKY_SLUZBY" strong={true} /> */}
            <h3>
                <TranslateText>PODMINKY_SLUZBY</TranslateText>
            </h3>

            <div className="section-podminky-sluzby">
                <ol
                    style={{
                        paddingLeft: '24px'
                    }}
                >
                    <li className="podminka">
                        <TranslateText>PODMINKY_P1</TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>PODMINKY_P2</TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>PODMINKY_P3</TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>PODMINKY_P4</TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>PODMINKY_P5</TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>PODMINKY_P6</TranslateText>
                        <br />
                        <br />
                        <TranslateText>ComGate Payments, a.s.</TranslateText>
                        <br />
                        <TranslateText>Gočárova třída 1754 / 48b, Hradec Králové</TranslateText>
                        <br />
                        <TranslateText>E-mail: platby-podpora@comgate.cz</TranslateText>
                        <br />
                        <TranslateText>Tel: +420 228 224 267 </TranslateText>
                        <br />
                    </li>
                </ol>

                <div className="comgate-images">
                    <img src={paymentMethods} width={520} alt="Payment methods" />
                </div>
            </div>

            <Row className="statement-buttons-row">
                <ButtonComponent
                    htmlType="button"
                    buttontext="ZPET"
                    onClick={() => setShowTerms && setShowTerms(false)}
                />
            </Row>
        </StatementWrapper>
    );
};

export default ObchodniPodminky;
